<template>
 <v-form ref="messageForm" v-model="valid" lazy-validation>
            <v-container grid-list-xl text-xs-center>
              <v-flex class="text-xs-left">
                <v-icon large>ti-comments</v-icon>
                <h1 headline class="headText text-xs-left">Event communication</h1>
              </v-flex>
              <v-layout row wrap justify-space-around>
                <v-card class="innerCards elevation-0">
                  <h2 class="text-xs-left ml-4">New communication</h2>
                  <v-divider></v-divider>
                  <v-card class="innerScrollableCards elevation-0">
                    <v-layout row>
                      <v-flex xs11 class="ml-4 mt-1">
                        <h3 class="text-xs-left">{{$translate('EVENT_MESSAGE_TITLE')}}</h3>
                        <v-text-field
                          class="maxTextHeight"
                          :counter="50"
                          required
                          single-line
                          maxlength="50"
                          outline
                          v-model="messageForm.Title"
                          :rules="eventRule"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip max-width="250" bottom>
                          <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
                          <span>{{$translate('EVENT_MSG_TITLE_INFO')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs11 class="ml-4 mt-1">
                        <h3 class="text-xs-left">{{$translate('EVENT_MESSAGE_TEXT')}}</h3>
                        <v-textarea
                          class="maxTextHeight"
                          :counter="140"
                          required
                          outline
                          maxlength="140"
                          rows="6"
                          single-line
                          v-model="messageForm.Text"
                          :rules="eventRule"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip max-width="250" bottom>
                          <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
                          <span>{{$translate('EVENT_MSG_TEXT_INFO')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs11 class="ml-4 mt-1">
                        <h3 class="text-xs-left">{{$translate('EVENT_MESSAGE_REW_LVL')}}</h3>
                        <v-select
                          class="maxTextHeight"
                          :items="rewardTypes"
                          required
                          outline
                          v-model="messageForm.toEventRewardLevel"
                          :rules="eventRule"
                        ></v-select>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip max-width="250" bottom>
                          <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
                          <span>{{$translate('EVENT_MSG_RWD_LVL_INFO')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs11 class="ml-4">
                        <h3 class="text-xs-left">{{$translate('EVENT_USER_SELECTION')}}</h3>
                        <v-select
                          class="maxTextHeight"
                          :items="userSelections"
                          required
                          outline
                          item-text="criteriaName"
                          item-value="criteriaId"
                          v-model="messageForm.ToEventSubscribers"
                          :rules="eventRule"
                        ></v-select>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip max-width="250" bottom>
                          <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
                          <span>{{$translate('EVENT_MSG_USER_SEL_INFO')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 class="BgInputFieldsTime ml-4">
                        <v-tooltip max-width="250" bottom>
                          <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                          <span>{{$translate('EVENT_MSG_DATE_INFO')}}</span>
                        </v-tooltip>
                        <h3 class="text-xs-left">{{$translate('EVENT_DATE')}}</h3>
                        <v-menu
                          ref="messageDateForm"
                          :close-on-content-click="true"
                          v-model="messageDateForm"
                          :nudge-right="40"
                          :return-value.sync="tmpMessageDate"
                          lazy
                          :min="nowDate"
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            single-line
                            slot="activator"
                            v-model="computedDateFormattedMessageDate"
                            :rules="eventRule"
                            required
                            outline
                            append-icon="event"
                            readonly
                            class="maxBGTextHeight"
                          ></v-text-field>
                          <v-date-picker
                            :min="nowDate"
                            first-day-of-week="1"
                            v-model="tmpMessageDate"
                            @input="selectingMessageDate"
                            no-title
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex xs6 class="BgInputFieldsTime ml-4">
                        <v-tooltip max-width="250" bottom>
                          <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                          <span>{{$translate('EVENT_MSG_TIME_INFO')}}</span>
                        </v-tooltip>
                        <h3 class="text-xs-left">{{$translate('EVENT_TIME')}}</h3>
                        <v-text-field
                          class="maxBGTextHeight"
                          type="time"
                          required
                          mask="time"
                          hint="Example: 18:00"
                          single-line
                          outline
                          append-icon="access_time"
                          v-model="messageForm.Time"
                          :rules="eventRule"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs11 class="ml-4">
                        <h3 class="text-xs-left">{{$translate('EVENT_COMM_TYPE')}}</h3>
                        <v-combobox
                          class="maxTextHeight"
                          :items="messageType"
                          required
                          :rules="eventRule"
                          single-line
                          outline
                          v-model="messageForm.CommunicationType"
                        >
                          <template slot="item" slot-scope="data">
                            <v-icon class="mr-1">{{data.item.avatar }}</v-icon>
                            <span class="cb-item">{{ data.item.value}}</span>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip max-width="250" bottom>
                          <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
                          <span>{{$translate('EVENT_MSG_COMM_TYPE_INFO')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex class="text-xs-left ml-4">
                        <v-btn round color="secondary" @click="$refs.messageForm.reset()">Clear</v-btn>
                      </v-flex>
                      <v-flex class="text-xs-right mr-4">
                        <v-btn round color="primary" @click="saveMessage()">Add</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-card>
                <v-card class="innerCards elevation-0">
                  <h2 class="text-xs-left ml-4">Messages overview</h2>
                  <v-divider></v-divider>
                  <v-card
                    v-if="eventMessages.length == 0"
                    class="innerScrollableBatchGroupCards elevation-0"
                  >
                    <strong text-xs-center>No messages available</strong>
                  </v-card>
                  <v-card v-else class="innerScrollableBatchGroupCards elevation-0">
                    <v-card
                      class="text-xs-left pl-1 elevation-0 batchGroupCards"
                      v-for="(item,index) in eventMessages"
                      :key="index"
                    >
                      <v-flex>
                        <p>
                          <strong>{{$translate('EVENT_DATE')}}:</strong>
                          {{item.DateTime}}
                          <br>
                          <strong>{{$translate('EVENT_MESSAGE_TITLE')}}:</strong>
                          {{item.Title}}
                          <br>
                          <strong>{{$translate('EVENT_USER_SELECTION')}}:</strong>
                          {{item.ToEventSubscribers}}
                          <br>
                          <strong>{{$translate('EVENT_MESSAGE_STATUS')}}</strong>
                          <i v-if="item.Handled == '0'">{{$translate('EVENT_MESSAGE_NOT_SEND')}}</i>
                          <i v-if="item.Handled == '1'">{{$translate('EVENT_MESSAGE_SEND')}}</i>
                        </p>
                      </v-flex>
                      <v-btn
                        class="editMessageButton"
                        color="primary"
                        small
                        icon
                        @click="editMessage(item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        class="deleteMessageButton"
                        color="primary"
                        icon
                        @click="deleteMessage(item)"
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </v-card>
                  </v-card>
                </v-card>
              </v-layout>
            </v-container>
            <v-dialog v-model="deleteMessageDialog" max-width="290" hide-overlay>
                <v-card>
                    <v-card-title
                    class="headline"
                    :style="`color: ${$vuetify.theme.primary}`"
                    >{{$translate('MESSAGE_DELETION')}}</v-card-title>
                    <v-card-text>{{$translate('EVENT_DEL_MESSAGE')}}</v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="secondary"
                        class="v-btn-2 text-capitalize"
                        round
                        @click.native="deleteMessageDialog = false"
                    >{{$translate('CANCEL')}}</v-btn>
                    <v-btn
                        color="primary"
                        class="v-btn-2 text-capitalize"
                        round
                        @click.native="deleteMessageConfirmation"
                    >{{$translate('DELETE')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
          </v-form>
</template>

<script>
import { ui_helpers } from "../shared/ui_helpers"; // Mandatory to reach the ShowComponents functions and other snippets
import appConfig from "../../config/app_config"; // Mandatory to reach the dss objects and other info
import * as dssRequest from "../api/dssRequest"; // Mandatory to do a request for data
import WizardMessageObject from "@/objects/WizardMessageObject.js"; // Mandatory to create the request object for messages
import { objectToArray } from "@/shared/utility.js"; // Mandatory to create array of objects from object of objects
import BaseObject from "@/objects/BaseObject.js"; // Mandatory to create array of objects from objject of objects
import _ from "lodash"; // Mandatory to use the lodash accessibilities

export default {
  name: "EventWizard_EventCommunication",
  components: {
    // Importing the components that are used within this component
  },
  mixins: [ui_helpers],
  props: {
    newEventId: {
      type: String
    },
    eventForm: Object
  },
  computed: {
    computedDateFormattedStartDate() {
      // format the start date for better visualisation of the date
      return this.formatDate(this.tmpStartDate);
    },
    computedDateFormattedEndDate() {
      // format the start date for better visualisation of the date
      return this.formatDate(this.tmpEndDateSuggested);
    },
    computedDateFormattedMessageDate() {
      // format the start date for better visualisation of the date
      return this.formatDate(this.tmpMessageDate);
    }
  },
  watch: {
  },
  mounted() {
    console.log("eventForm", this.eventForm)
  },
  data() {
    return {
      // Variables
      valid                  : true,
      messageDateForm        : false,
      nowDate                : new Date().toISOString().slice(0, 10),
      tmpMessageDate         : null,
      eventMessages          : [],
      messageToBeDelete      : {},


      // Form objects
      messageForm         : {},

      // Dialogs
      deleteMessageDialog   : false,


      // Rules
      eventRule       : [v => !!v || "This field is required"],
      inputNumberRules: [
        (v => !!v && v !== 0) || "This field is required",
        v => (v && v > -1) || "Must be 0 or higher"
      ],

      // Hard-coded !-- TODO make it dynamically --!
       messageType: [
        { text: "Mail/Message", value: "Mail/Message", avatar: "ti-comments" },
        {
          text    : "Facebook",
          value   : "Facebook",
          disabled: true,
          avatar  : "ti-facebook"
        },
        {
          text    : "Twitter",
          value   : "Twitter",
          disabled: true,
          avatar  : "ti-twitter"
        },
        {
          text    : "Instagram",
          value   : "Instagram",
          disabled: true,
          avatar  : "ti-instagram"
        }
      ],
      rewardTypes   : ["All", "Gold", "Silver", "Bronze"],
      userSelections: [
        { criteriaId: 1, criteriaName: this.$translate("CRITERIA_BOTH") },
        { criteriaId: 2, criteriaName: this.$translate("CRITERIA_REG") },
        { criteriaId: 3, criteriaName: this.$translate("CRITERIA_NOT_REG") }
      ],

    };
  },
  created() {
    window.EventBus.listen("getMessages", this.getMessages);
  },
  beforeDestroy() {
    window.EventBus.removeListener("getMessages", this.getMessages);
  },
  methods: {
    saveMessage() {
      // Saving a message (campaign message)
      if (!this.$refs.messageForm.validate()) {
        return false;
      }
      console.log("saveSingleMessage the form is ", this.messageForm);
      this.messageForm.EventId = this.newEventId;
      this.messageForm.Date = this.tmpMessageDate;
      this.messageForm.ToEventSubscribers =
        this.messageForm.ToEventSubscribers - 1;

      // Check if message is send before the current time on the current day
      let currentDateCheck = new Date();
      let currentTimeCheck = currentDateCheck
        .toLocaleTimeString()
        .slice(0, 5)
        .split(":")
        .join("");
      console.log(
        "chech this pleas...",
        this.messageForm.Date,
        currentDateCheck,
        this.messageForm.Time,
        currentTimeCheck
      );
      if (this.messageForm.Time < currentTimeCheck) {
        this.errorDialog = true;
        this.recievedErrorMessage =
          "Your time input is earlier than the current time ( current time is: " +
          currentDateCheck.toLocaleTimeString().slice(0, 5) +
          "), please change this and continue.";
        return false;
      }

      let payload = WizardMessageObject._saveMessageObject(this.messageForm);
      console.log("paylaoddd", payload);
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      payload.FunctionId = "MessageFunctionLibrary::saveMessage";

      dssRequest.doRequest(
        response => {
          console.log("the generic call saveMessage was successful", response);
          window.EventBus.fire(
            "activateSnackBar",
            "Message saved successfully !"
          );
          this.messageForm = {};
          this.$refs.messageForm.reset();
          this.tmpMessageDate = null;
          this.getMessages();
        },
        error => {
          console.log(
            "The generic call saveMessage was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId + "_CMR",
        payload
      );
    },
    getMessages() {
      // Retrieving all the messages belonging to the event
      let payload = WizardMessageObject._eventSavedMessagesRequestObject(
        this.newEventId
      );
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      payload.FunctionId = "MessageFunctionLibrary::getSavedMessages";
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getSavedMessaged was successful",
            response
          );
          this.eventMessages = [];
          let messages = [];
          if (!response.data.hasOwnProperty("CommunicationUnits")) {
            messages = [];
          } else {
            messages = BaseObject._createArrayWithObjects(
              response.data.CommunicationUnits
            );
          }
          for (let [key, value] of Object.entries(messages)) {
            value.DateTime = value.DateTime.split(" ")
              .reverse()
              .join(" - ");
            if (value.ToEventSubscribers == "0") {
              value.ToEventSubscribers = this.$translate("CRITERIA_BOTH");
            } else if (value.ToEventSubscribers == "1") {
              value.ToEventSubscribers = this.$translate("CRITERIA_REG");
            } else {
              value.ToEventSubscribers = this.$translate("CRITERIA_NOT_REG");
            }
            this.eventMessages.push(value);
          }
          console.log("events messages", this.eventMessages);
        },
        error => {
          console.log(
            "The generic call getSavedMessaged was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId + "_CMR",
        payload
      );
    },
    editMessage(item) {
      console.log("item?!", item);
      let d = item.DateTime.split(" - ")[1]
        .split("-")
        .reverse()
        .join("-");
      let t = item.DateTime.split(" - ")[0];

      this.tmpMessageDate = d;
      item.Time = t;
      if (item.ToEventSubscribers != null) {
        if (item.ToEventSubscribers == 0) {
          item.ToEventSubscribers = this.userSelections[0].criteriaId;
        } else if (item.ToEventSubscribers == 1) {
          item.ToEventSubscribers = this.userSelections[1].criteriaId;
        } else {
          item.ToEventSubscribers = this.userSelections[2].criteriaId;
        }
      } else {
        item.ToEventSubsribers = this.userSelections[0];
      }
      if ((item.Handled = "1")) {
        delete item.UnitId;
      }
      this.messageForm = item;
    },
    deleteMessage(item) {
      // Dialog to delete the batchgroup
      this.messageToBeDelete = item;
      this.deleteMessageDialog = true;
    },
    deleteMessageConfirmation() {
      // Deleting the chosen message
      let payload = {
        UnitId: this.messageToBeDelete.UnitId,
        FunctionId: "MessageFunctionLibrary::deleteMessage"
      };

      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call deleteMessage was successful",
            response
          );
          this.getMessages();
          setTimeout(() => {
            this.deleteMessageDialog = false;
          }, 10);
        },
        error => {
          console.log(
            "The generic call deleteMessage was not successful",
            error
          );
          setTimeout(() => {
            this.deleteMessageDialog = false;
          }, 10);
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId + "_CMR",
        payload
      );
    },
    formatDate(date) {
      // Formatting the date to right output
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    selectingMessageDate() {
      // Saving the date for a message in the input field
      this.$refs.messageDateForm.save(this.tmpMessageDate);
    },
  }
};
</script>


<style lang = "scss", scoped>
.headText {
  margin-top: -1.5em;
  margin-left: 2.2em;
  margin-bottom: 1em;
}

.maxTextHeight {
  margin-top: -0.5em !important;
  transform: scale(0.85);
  transform-origin: left;
}

.infoPositionTop {
  margin-left: -2.8em;
  margin-bottom: -1.2em;
}

.infoTimePosition {
  margin-left  : 1.5em;
  margin-bottom: -0.8em;
}

.innerCards {
  max-height   : calc(45vh) !important;
  margin-bottom: 2em;
  min-height   : 20em;
  min-width    : 25em;
  border       : 1px solid black !important;
  border-radius: 3em !important;
  max-width    : 20em !important;
}

.innerScrollableCards {
  margin-top   : 0.5em;
  margin-right : 0.5em;
  margin-bottom: 2em !important;
  max-height   : calc(37vh) !important;
  overflow-y   : auto;
  overflow-x   : hidden;
}

.batchGroupCards {
  max-height      : 9em !important;
  margin-left     : 0.3em;
  margin-top      : 0.3em;
  margin-bottom   : 0.1em !important;
  max-width       : 95% !important;
  background-color: #c0ccdf !important;
  border-radius   : 1em !important;
  border          : 1px solid black !important;
}

.innerScrollableBatchGroupCards {
  margin-top   : 0.5em;
  margin-right : 0.5em;
  margin-bottom: 2em !important;
  min-height   : calc(37vh) !important;
  max-height   : calc(37vh) !important;
  overflow-y   : auto;
  overflow-x   : hidden;
}

.maxBGTextHeight {
  margin-top      : -0.5em !important;
  transform       : scale(0.8);
  transform-origin: left;
}


.BgInputFieldsTime {
  margin-top  : -3em;
  margin-right: -3em;
  margin-left : 1.5em !important;
}

.deleteMessageButton {
  margin-left: 85% !important;
  margin-top : -60%;
}

.editMessageButton {
  margin-left: 85% !important;
  margin-top : -70%;
}

/** checks if the media window is maximum 800px **/
@media (max-height: 800px) {
  .innerCards {
    max-height: calc(45vh) !important;
    min-height: 20em;
    min-width : 25em;
    max-width : 35em;
  }
}

/** checks if the media window is minimal 900px **/
@media (min-height: 900px) {
  .innerCards {
    max-height: calc(50vh) !important;
    min-height: 20em;
    min-width : 25em;
    max-width : 35em;
  }
}
</style>
